import styled from '@emotion/styled'
import { AnimatedMemoryAction } from 'components/memory/animatedMemoryAction/AnimatedMemoryAction'

export const SAnimatedMemoryAction = styled(AnimatedMemoryAction)`
  & path {
    stroke: var(--c-white);
  }
`
